// extracted by mini-css-extract-plugin
export default {"Boxes__subtitles":"Boxes_Boxes__subtitles__KbRLI","Boxes__subtext":"Boxes_Boxes__subtext__XWJ4K"};